module.exports = __webpack_public_path__ + "img/index.44d99a9f.png";